/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type AccountNavContent_viewer = {
    readonly nftMarketplaceEnabled: boolean | null;
    readonly nftPublicProfileEnabled: boolean | null;
    readonly " $refType": "AccountNavContent_viewer";
};
export type AccountNavContent_viewer$data = AccountNavContent_viewer;
export type AccountNavContent_viewer$key = {
    readonly " $data"?: AccountNavContent_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountNavContent_viewer",
    "selections": [
        {
            "alias": "nftMarketplaceEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "nftMarketplace"
                }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftMarketplace\")"
        },
        {
            "alias": "nftPublicProfileEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "nftPublicProfile"
                }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftPublicProfile\")"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '2c6ace26a41395b74644e876180cad2f';
export default node;
